import {Routes} from '@angular/router';
import {RootPageComponent} from './pages/gateway/root-page.component';
import {LoginComponent} from './pages/login/login.component';
import {AuthenticationGuard} from './guards/authentication.guard';
import {RootResolver} from "./services/root-resolver.service";
import {PlannerPageComponent} from './pages/planner/planner-page.component';
import {LoginResolver} from './pages/login/login.resolver';
import {InstallBuildingComponent} from "./pages/gateway/components/install-building/install-building.component";
import {InstallGeneralComponent} from "./pages/gateway/components/install-general/install-general.component";
import {InstallHeatingComponent} from "./pages/gateway/components/install-heating/install-heating.component";
import {InstallPhotosComponent} from "./pages/gateway/components/install-photos/install-photos.component";
import {InstallSensorsComponent} from "./pages/gateway/components/install-sensors/install-sensors.component";
import {
  InstallGeneralGatewayComponent
} from "./pages/gateway/components/install-general/components/install-general-gateway/install-general-gateway.component";
import {
  InstallGeneralPrePhotosComponent
} from "./pages/gateway/components/install-general/components/install-general-pre-photos/install-general-pre-photos.component";
import {
  InstallGeneralMeasurementComponent
} from "./pages/gateway/components/install-general/components/install-general-measurement/install-general-measurement.component";
import {
  InstallGeneralSendingComponent
} from "./pages/gateway/components/install-general/components/install-general-sending/install-general-sending.component";
import {
  InstallHeatingInformationComponent
} from "./pages/gateway/components/install-heating/components/install-heating-information/install-heating-information.component";
import {
  InstallHeatingCheckComponent
} from "./pages/gateway/components/install-heating/components/install-heating-check/install-heating-check.component";
import {
  InstallSensorsTemperatureComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-temperature/install-sensors-temperature.component";
import {
  InstallSensorsPumpComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-pump/install-sensors-pump.component";
import {
  InstallSensorsCounterComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-counter/install-sensors-counter.component";
import {
  InstallSensorsControlComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-control/install-sensors-control.component";
import {
  InstallSensorsOtherComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-other/install-sensors-other.component";
import {LoginResetPasswordComponent} from "./pages/login/components/reset-password/login-reset-password.component";

export const SHELL_ROUTES: Routes = [
  {
    path: '',
    children: [
      {path: '', redirectTo: '/gateway', pathMatch: 'full'},
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
    resolve: [LoginResolver]
  },
  {
    path: 'reset-password/:token',
    component: LoginResetPasswordComponent,
  },
  {
    path: 'gateway',
    canActivate: [AuthenticationGuard],
    resolve: [RootResolver],
    component: RootPageComponent,
    children: [
      {path: '', redirectTo: 'general', pathMatch: 'full'},
      {
        path: 'general',
        component: InstallGeneralComponent,
        children: [
          {path: '', redirectTo: 'gateway', pathMatch: 'full'},
          {path: 'gateway', component: InstallGeneralGatewayComponent},
          {path: 'pre-photos', component: InstallGeneralPrePhotosComponent},
          {path: 'measurement', component: InstallGeneralMeasurementComponent},
          {path: 'sending', component: InstallGeneralSendingComponent},
        ]
      },
      {path: 'building', component: InstallBuildingComponent},
      {
        path: 'heating',
        component: InstallHeatingComponent,
        children: [
          {path: '', redirectTo: 'information', pathMatch: 'full'},
          {path: 'information', component: InstallHeatingInformationComponent},
          {path: 'check', component: InstallHeatingCheckComponent},
        ]
      },
      {
        path: 'sensors',
        component: InstallSensorsComponent,
        children: [
          {path: '', redirectTo: 'temperature', pathMatch: 'full'},
          {path: 'temperature', component: InstallSensorsTemperatureComponent},
          {path: 'pump', component: InstallSensorsPumpComponent},
          {path: 'counter', component: InstallSensorsCounterComponent},
          {path: 'control', component: InstallSensorsControlComponent},
          {path: 'other', component: InstallSensorsOtherComponent},
        ]
      },
      {path: 'photos', component: InstallPhotosComponent},
    ],
  },
  {
    path: 'planner',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        component: PlannerPageComponent,
      }
    ],
  },

  {path: '**', redirectTo: '/gateway'},
];
